export default "__VITE_ASSET__48ca4cbc__"